<template>
<div class="col-12 text-left">
    <h3 class="p-2">
        <small class="text-muted">Quality Approval Detail</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-3">
            <label>Start Date</label>
            <flat-pickr class="form-control" disabled v-model="aq.startDate"></flat-pickr>
        </div>
        <div class="form-group col-3">
            <label>Due Date</label>
            <flat-pickr class="form-control" disabled v-model="aq.dueDate"></flat-pickr>
        </div>
        <div class="form-group col-3">
            <label>Request Sample Approved</label>
            <input type="checkbox" class="form-control" disabled v-model="aq.isApprovedRS" id="isApprovedRS">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-3">
            <label for="srNumber">SR Number</label>
            <input type="text" class="form-control" disabled v-model="aq.srNumber" id="srNumber" aria-describedby="code">
        </div>
        <div class="form-group col-3">
            <label>Product</label>
            <input type="text" class="form-control" disabled v-model="aq.product" id="product">
        </div>
        <div class="form-group col-3">
            <label>Customer</label>
            <input type="text" class="form-control" disabled v-model="aq.customer" id="customer">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-3">
            <label>Destination</label>
            <input type="text" class="form-control" disabled v-model="aq.destination" id="destination">
        </div>
        <div class="form-group col-3">
            <label>Address</label>
            <input type="text" class="form-control" disabled v-model="aq.address" id="address">
        </div>
        <div class="form-group col-3">
            <label>Schedule Product</label>
            <input type="text" class="form-control" v-model="aq.scheduleProduct" id="scheduleProduct">
        </div>
    </div>
     <div class="row">
        <div class="form-group col-3">
            <label>Approved By</label>
            <input type="text" disabled class="form-control" v-model="aq.approvedByName" id="approvedByName">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-9">
            <label for="desc-textarea">Remark from Request Sample</label>
            <textarea class="form-control" id="desc-textarea" v-model="aq.remarkRS" rows="3" disabled></textarea>
        </div>
        <div class="form-group col-9">
            <label for="desc-textarea">Remark</label>
            <textarea class="form-control" id="desc-textarea" v-model="aq.remark" rows="3"></textarea>
        </div>
    </div>
    <app-lookup-modal ref="awbModal" :element="modalElements"></app-lookup-modal>
    <app-datatable :type="'view'" @buttonInlineClicked="checkAWB" :elements="dtElements" :collections="aq.approvedQualityDetail"></app-datatable>
    <app-datatable :type="'input'" :newData="newDetailGantt" :elements="dtElementsGantt" :collections="aq.approvedQualityGanttChart"></app-datatable>

    <button type="button" class="btn btn-outline-info" @click="renderGantt">Update Chart <i class="fas fa-drafting-compass"></i></button>
    <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
    <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
    <button type="button" class="btn btn-outline-danger" @click="close">Request Close <i class="fas fa-power-off"></i></button>
     <!-- <frappe-gantt
            :view-mode="mode"
            :tasks="aq.approvedQualityGanttChart"
             /> -->
    <app-gantt :tasks="aq.approvedQualityGanttChart"></app-gantt>
</div>
</template>

<script>
import api from '../../services/api'
import { approvedQuality, approvedQualityDetail, approvedQualityGanttChart } from '../../models/approvedQuality'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppGantt from '../../components/AppGantt.vue';
import AppModal from '../../components/AppModal.vue'
import AppLookupModal from '../../components/AppLookupModal'
import { listGanttChart } from '../../config'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppGantt, AppModal, AppLookupModal
    },
    data() {
        return {
            mode: 'day',
            tasks: [],
            aq: {
                ...approvedQuality,
                approvedQualityDetail: [],
                approvedQualityGanttChart: [],
            },
            awbNumber: '',
            modalElements: {
                id: 'AWB',
                title: 'AWB History',
                content: '',
                searchBar: false,
                type: 'table',
                filter: ['description', 'area', 'date', 'time'],
                needAutoClose: false,
                dtElements: [
                    {
                        id: 'description',
                        title: 'Description',
                        type: 'text',
                        column: 'description'
                    },
                    {
                        id: 'area',
                        title: 'Area',
                        type: 'text',
                        column: 'area'
                    },
                    {
                        id: 'date',
                        title: 'Date',
                        type: 'text',
                        column: 'date'
                    },
                    {
                        id: 'time',
                        title: 'Time',
                        type: 'text',
                        column: 'time'
                    },
                ]
            },
            newDetail: approvedQualityDetail ,
            dtElements: [
                {
                    title: 'Spec',
                    column: 'spec',
                    type: 'link',
                    disable: true
                },
                {
                    title: 'Spec QA',
                    column: 'specQA',
                    type: 'upload',
                    width: 5
                },
                {
                    title: 'Name',
                    column: 'remark',
                    type: 'text',
                    width: 2,
                    disable: true
                },
                {
                    title: 'Qty',
                    column: 'qty',
                    type: 'number',
                    width: 2,
                    disable: true
                },
                {
                    title: 'UOM',
                    column: 'UOM',
                    type: 'text',
                    width: 3,
                    disable: true
                },
                {
                    title: 'Sample Cost / MT',
                    column: 'sampleCostMT',
                    type: 'number',
                    width: 3,
                    disable: true
                },
                {
                    title: 'Sample Cost',
                    column: 'sampleCost',
                    type: 'text',
                    width: 3,
                    disable: true
                },
                {
                    title: 'Dangerous Goods',
                    column: 'DG',
                    type: 'checkbox',
                    width: 1,
                    disable: true
                },
                {
                    title: 'Courier',
                    column: 'courier',
                    type: 'checkbox',
                    width: 1,
                    disable: true
                },
                {
                    title: 'Paid',
                    column: 'paid',
                    type: 'checkbox',
                    width: 1,
                    disable: true
                },
                {
                    title: 'Carrier Cost',
                    column: 'carrierCost',
                    type: 'text',
                    width: 2,
                    disable: true
                },
                {
                    title: 'Courier Information Number',
                    column: 'courierInformationNumber',
                    type: 'text',
                    width: 3,
                    disable: true
                },
                {
                    title: 'Check AWB Status',
                    type: 'button-inline',
                    text: 'Check AWB'
                },
            ],
            newDetailGantt: approvedQualityGanttChart ,
            dtElementsGantt: [
                {
                    title: 'Gantt Chart Name',
                    column: 'name',
                    // type: 'dropdown',
                    // width: 15,
                    type: 'dropdown',
                    width: 15,
                    lists: [
                        ...listGanttChart
                    ]
                },
                {
                    title: 'Start Date',
                    column: 'start',
                    type: 'date',
                    width: 5,
                },
                {
                    title: 'End Date',
                    column: 'end',
                    type: 'date',
                    width: 5,
                }
            ]
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const aqApi = api('approved-quality')
            this.aq = await aqApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const aqApi = api('approved-quality')
            if(this.$route.query.id !== undefined) {
                await aqApi.update(this.aq, this.$route.query.id)
            } else {
                await aqApi.create(this.aq)
            }
            this.$router.go(-1)
        },
        async close() {
            const aqApi = api('close-approved-quality')
            if(this.$route.query.id !== undefined) {
                await aqApi.update(this.aq, this.$route.query.id)
            } else {
                await aqApi.create(this.aq)
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentSR = this.aq
            this.aq = {
                ...currentSR,
                ...data
            }
        },
        renderGantt() {
            const newGantt = this.aq.approvedQualityGanttChart
            this.aq.approvedQualityGanttChart.splice(0, this.aq.approvedQualityGanttChart.length, ...newGantt)
        },
        async checkAWB(value) {
            this.awbNumber = this.aq.approvedQualityDetail[value].courierInformationNumber

            const payload = {
                apiUrl: 'customer-gateway/check-AWB',
                payload: {
                    searchKey: this.awbNumber
                }
            } 
            this.$refs[`awbModal${ this.rowIndex || '' }`].fetchCollectionDataByParamsPost(payload)

            let modal = this.$refs.awbModal.$el
            $(modal).modal('show')
        }
    }
}
</script>